import utils from '@/mixins/utils.js'

export const dataFieldsPercentual = {
  'N°': 'colocacao',
  CNES: 'nu_cnes',
  UBS: 'no_unidade_saude',
  INE: {
    field: 'nu_ine',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },
  Equipe: 'no_equipe',

  'Nota prevista': {
    field: 'nota_previsto_exportacao',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },
  'Nota realizada': {
    field: 'nota_realizado_exportacao',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },

  'Pontuação prevista': {
    field: 'resultado_previsto_exportacao',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },
  'Pontuação realizada': {
    field: 'resultado_realizado_exportacao',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },

  'Classificação prevista': {
    field: 'classificacao_previsto_exportacao',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },
  'Classificação realizada': {
    field: 'classificacao_realizado_exportacao',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },
}

export const infoHtml = `
`
